export const downloadFile = (res,name) => {
  const blob = new Blob([res.data])
  const contentDisposition = res.headers['Content-Disposition'] || res.headers['content-disposition']
  let fileName
  if(contentDisposition){
    const patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
    fileName = patt.exec(contentDisposition)[1]
    //  避免返回 name 携帶雙引號
    fileName = fileName.replace(/\"/g, '')
  }else{
    fileName = name
  }

  const elink = document.createElement('a')
  if(fileName){
    elink.download = fileName
  }
  elink.style.display = 'none'
  elink.href = window.URL.createObjectURL(blob)
  document.body.appendChild(elink)
  elink.click()
  window.URL.revokeObjectURL(elink.href)
  document.body.removeChild(elink)
}
export const downloadFileName = (url,name) => {
  const url2 = url.replace(/\\/g, '/')
  let xhr
  if (window.XMLHttpRequest)
  {// code for all new browsers
    xhr=new XMLHttpRequest()
  }
  else if (window.ActiveXObject)
  {// code for IE5 and IE6
    xhr=new ActiveXObject('Microsoft.XMLHTTP')
  }
  xhr.open('GET', url2, true)
  xhr.responseType = 'blob'
  // 为了避免大文件影响用户体验，建议加loading
  xhr.onload = () => {
    if (xhr.status === 200) {
      // 获取文件blob数据并保存
      saveAs(xhr.response, name)
    }
  }
  xhr.send()

}
const saveAs =(data,name) =>{
  const urlObject = window.URL || window.webkitURL || window
  const export_blob = new Blob([data])
  //此方法可返回一个 Element 对象。
  if (window.navigator.msSaveBlob) {
    try {
      window.navigator.msSaveBlob(export_blob, name)
    } catch (e) {
      console.log(e)
    }
  }
  else{
    const save_link = document.createElement('a')
    save_link.href = urlObject.createObjectURL(export_blob)
    save_link.download = name
    document.body.appendChild(save_link)
    save_link.click()
    document.body.removeChild(save_link)
  }
}